import { checkEmailActionTaskStatus } from '../../Email.api'

import { EMAIL_MASS_MAILING_TASK_STATUS_INTERVAL } from './useMassMailingAsyncAction.constants'

export function checkTaskStatus(params, handler) {
  return checkEmailActionTaskStatus(params.task).then(({ data }) => {
    if (data.ready) {
      handler({ ...data, ...params })
    } else {
      setTimeout(
        () => checkTaskStatus(params, handler),
        EMAIL_MASS_MAILING_TASK_STATUS_INTERVAL
      )
    }
  })
}
